var React = require('react');
var ReactNative = require('react-native');

var PlatformConstants = require('./constants/PlatformConstants');
var Animated = require('./wrappers/Animated')

var Camera = require('./wrappers/react-native-camera-wrapper');
var Icon = require('./wrappers/ReUpIcon');
var ReUpText = require('./ReUpText');
var ReUpIconButton = require('./ReUpIconButton');
var RNFS = require('./wrappers/react-native-fs');

var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton
} = MK;
var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;

var {
  AppRegistry,
  Text,
  View,
  Image,
  TouchableHighlight,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  Platform,
} = ReactNative;

var ModelConstants = require('./constants/ModelConstants');

var MENU_WIDTH = 250;
var MENU_ADDITIONAL_WIDTH = 0;//80;
var MENU_EXPANDED_LEFT = -MENU_ADDITIONAL_WIDTH;
var MENU_UNEXPANDED_LEFT = -MENU_WIDTH - 2*MENU_ADDITIONAL_WIDTH;

var Menu = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      menuExpandedChanged : function(){},
      menuFeatures : [],
      menuIconColor : '#F00',
      menuTitleColor : '#444',
      menuHighlightColor : '#FF0',
      menuSeparatorColor : '#FF0',
      AppActions : null,
      appManager : null,
      style : {},
    }
  },

  getInitialState : function()
  {
    var showProfile = this.props.appManager.shouldUseFloatingNav();

    return {
      isExpanded : false,
      menuLeft : new Animated.Value(MENU_UNEXPANDED_LEFT),
      dismissOpacity : new Animated.Value(0),
      layout : {x:0,y:0,width:0,height:0},
      selfieURL : null,
      showProfile:showProfile
    }
  },

  _context : 0,
  componentDidMount : function()
  {
    this.props.appManager.getSelfie((selfieURL)=>this.setState({selfieURL}));
    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.selfieURL !== 'undefined' ) this.setState({selfieURL:newProps.selfieURL});
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  profilePicSelected : function()
  {
    if( Platform.OS === 'ios' )
    {
      var thisThing = this;
      var appActions = this.props.AppActions;
      Camera.checkVideoAuthorizationStatus().then((hasPermission)=>
      {
        if( hasPermission )
        {
          thisThing.showCamera();
        }
        else
        {
          appActions.showAlert("Camera Permission Required","You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.",["Okay"],[function(){appActions.hideAlert();}]);
        }
      })
    }
    else
    {
      this.showCamera();
    }
  },

  _camera : null,
  _canCapture : false,
  cameraDidLoad : function(camera)
  {
    if( !camera ) return;
    this._canCapture = true;
    this._camera = camera;
  },

  takePicture : async function()
  {
    if( this._camera && this._canCapture )
    {
      this._canCapture = false;
      try
      {
        var appManager = this.props.appManager;
        var thisThing = this;
        var data = await this._camera.capture({target:Camera.constants.CaptureTarget.disk, mode:Camera.constants.CaptureMode.still, type:Camera.constants.Type.front, quality:'medium'});
          // console.log(data);
        appManager.setSelfie(data, function()
        {
          // console.log("did set selfie")
          appManager.getSelfie(function(selfieURL)
          {
            // console.log("did get selfie with url" + selfieURL)
            thisThing.props.AppActions.hideAlert();
            thisThing.setState({selfieURL:selfieURL})
          })
        });
      } catch (e) {
        console.error(e);
      }
    }
  },

  checkUserChanged : function()
  {
    var thisThing = this;
    this.props.appManager.getSelfie(function(selfieURL)
    {
      thisThing.setState({selfieURL:selfieURL})
    })
  },

  showCamera : function()
  {
    var cameraDim = Math.min(this.props.layout.width,this.props.layout.height) - 20;
    var thisThing = this;
    var appManager = thisThing.props.appManager;

    var customAlert = Platform.OS === 'ios' ?
        <ScrollView bounces={true} style={{margin:0,padding:0}}
          keyboardShouldPersistTaps={'always'}
          showsVerticalScrollIndicator={false}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={
            {
              alignSelf:'center',
              height:cameraDim,width:cameraDim,
              justifyContent:'flex-end',
              padding:10
            }}
            captureAudio={false}
            captureQuality={"medium"}
            captureTarget={Camera.constants.CaptureTarget.disk}
            type={Camera.constants.Type.front}
            aspect={Camera.constants.Aspect.Fill}>
            <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
              appManager={appManager}
              style={{alignSelf:'flex-end'}}
                onPress={() => {
                  thisThing.takePicture();
                }}
                />
          </Camera>
        </ScrollView>
      :
        <ScrollView bounces={true} style={{margin:0,padding:0,paddingBottom:10}}
          keyboardShouldPersistTaps={'always'}
          showsVerticalScrollIndicator={false}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'flex-end', padding:10, marginBottom:10}}
            captureAudio={false}
            aspect={Camera.constants.Aspect.Fill}
            captureTarget={Camera.constants.CaptureTarget.disk}
            captureQuality={"medium"}
            type={Camera.constants.Type.front}
            orientation={Camera.constants.Orientation.portrait}>
          </Camera>
          <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
            appManager={appManager}
            style={{alignSelf:'flex-end'}}
              onPress={() => {
                thisThing.takePicture();
              }}
              />
        </ScrollView>;

    this.props.AppActions.setCustomAlertShown(true,customAlert);
  },

  setIsExpanded : function(isExpanded)
  {
    if( isExpanded == this.state.isExpanded ) return;

    this.setState({isExpanded:isExpanded});

    if( isExpanded )
    {
      this._ref_blur.setOpacity(1);
    }
    else
    {
      this._ref_blur.setOpacity(0);
    }
    this.props.menuExpandedChanged(isExpanded)
    Animated.spring(
      this.state.menuLeft,
      {
        toValue: isExpanded ? MENU_EXPANDED_LEFT : MENU_UNEXPANDED_LEFT,
        velocity: 3,
        tension: 6,
        friction: 7,
      },
    ).start();

    Animated.timing(
     this.state.dismissOpacity,
     {toValue: isExpanded ? 1 : 0,
     duration:300},
    ).start(function()
    {

    });
  },

  toggleIsExpanded : function()
  {
    this.setIsExpanded(!this.state.isExpanded);
  },

  viewDidLayout : function(info)
  {
    var currentLayout = info.nativeEvent.layout;
    var layout = info.nativeEvent.layout;

    if( layout.height != this.state.layout.height || layout.width != this.state.layout.width ) this.setState({layout:layout})
  },

  didSelectFeature : function(feature)
  {
    this.props.AppActions.requestFeatureName(feature.key)
  },

  render: function()
  {
    var menu = this;
    var style = this.props.style;
    if( typeof style === 'undefined' ) style = {};
    var appManager = this.props.appManager;
    var bgImage = this.props.appManager.absoluteResourceForPath('App/Menu.png');
    var menuColor = this.props.appManager.getColorForKey("MenuColor",1);
    var menuTitleColor = this.props.appManager.getColorForKey("MenuTitleColor",1);
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);

    var user = appManager.currentUser();
    var userFullName = "";
    var email = "";
    var currDollars = null;
    var currPoints = null;
    var creditString = null;
    var pointsString = null;
    var initials = null;
    var classNames = "";
    if( typeof user !== 'undefined' && user != null )
    {
      initials = appManager.currentUserInitials();
      userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
      email = user[ModelConstants.UserName];
      currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
      currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
      classNames = typeof appManager.currentUser()[ModelConstants.ClassNames] !== 'undefined' ? appManager.currentUser()[ModelConstants.ClassNames].join(", ") : "";
    }

    var useSelfie = (typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0);

    var thisThing = this;

    return (
      <View style={[{flex:1, alignSelf:'stretch', backgroundColor:menuColor},this.props.style]} onLayout={this.viewDidLayout}
        testID={"menu"}>
        <Image
          key={appManager.getImageKey("menubg")}
          style={[this.props.style,styles.image]}
          source={{uri: bgImage}}
        />
        <ScrollView bounces={false} showsVerticalScrollIndicator={false} keyboardShouldPersistTaps={'always'}>
          {
            this.state.showProfile && appManager.isLoggedIn() ?
              <View style={{flexDirection:'column', marginHorizontal:12, marginTop:12}}>
                <View style={{
                  flexDirection: 'row',
                  justifyContent:'center',
                  alignItems:'center',
                }}>
                  <View style={{
                    width:100,
                    height:100,
                    flexDirection:'row',
                    alignItems:'center',
                    justifyContent:'flex-start'
                  }}>
                    <TouchableHighlight
                      underlayColor={"transparent"}
                      activeOpacity={0.9}
                      onPress={() => {thisThing.profilePicSelected()}}>
                      <View style={{borderColor:profileColor, borderWidth:0, backgroundColor:profileColor, borderRadius:40, width:80, height:80}}>
                        {
                          useSelfie ?
                          <View style={{flex: 1}}>
                            <ReUpText appManager={appManager} style={{
                              textAlign:'center',
                              fontSize:40,
                              fontWeight:'bold',
                              backgroundColor:'transparent', position: 'absolute', bottom: 0, right: 0, top:16, left: 0}}>
                              {initials}
                            </ReUpText>
                            <Image source={{uri: this.state.selfieURL}} style={{backgroundColor:'transparent',margin:0, borderRadius:38, margin:1, flex:1, justifyContent:'center'}}>
                            </Image>
                          </View>
                          :
                          <View style={{flex:1,backgroundColor:profileImageColorLight, borderRadius:39, justifyContent:'center'}}>
                            <View>
                              <ReUpText appManager={appManager} style={{
                                textAlign:'center',
                                fontSize:40,
                                fontWeight:'bold',
                                backgroundColor:'transparent', color:profileImageColor}}>
                                {initials}
                              </ReUpText>
                            </View>
                            <View style={{position:'absolute', bottom:0, left:0, right:0, height:24, justifyContent:'center', alignItems:'center'}}>
                              <Icon name={"camera"} size={16} color={profileImageColor} />
                            </View>
                          </View>
                        }
                        <Svg
                          height={110}
                          width={110}
                          style={{position:'absolute', top:-10,left:-10, backgroundColor:'transparent'}}
                        >
                            <G scale="1">
                              <Circle cx="50" cy="50" r="39.5" stroke={profileImageColor} stroke-width={2} fill={'transparent'} />
                            </G>
                        </Svg>
                      </View>
                    </TouchableHighlight>
                  </View>
                  <View style={{flex:1, flexDirection:'column', paddingTop:8}}>
                    <ReUpText appManager={appManager} isTitle={true} style={{backgroundColor:'transparent', color:menuTitleColor}}>
                      {userFullName}
                    </ReUpText>
                    <ReUpText appManager={appManager} style={{backgroundColor:'transparent', color:menuTitleColor}}>
                      {email}
                    </ReUpText>
                    <View style={{flex:1}} />
                    <View style={{flexDirection: 'row', alignItems:'flex-start', flexWrap:'wrap', justifyContent: 'flex-start', marginBottom:6}}>
                      <View style={{flexDirection: 'row', alignItems: 'center', marginRight:20}}>
                        <Icon name={'pay-shortcut'} size={15} color={menuTitleColor} style={{backgroundColor:'transparent', color:menuTitleColor}} />
                        <ReUpText appManager={appManager} style={{backgroundColor:'transparent', color:menuTitleColor, marginLeft: 10}}>
                          {creditString}
                        </ReUpText>
                      </View>
                      <View style={{flexDirection: 'row', alignItems: 'center'}}>
                        <Icon name={'trophy'} size={15} color={menuTitleColor} style={{backgroundColor:'transparent', color:menuTitleColor}}/>
                        <ReUpText appManager={appManager} style={{backgroundColor:'transparent', color:menuTitleColor, marginLeft: 10}}>
                          {pointsString}
                        </ReUpText>
                      </View>
                    </View>
                    {
                      classNames.length > 0 ?
                        <View style={{flexDirection: 'row', justifyContent: 'flex-start'}}>
                          <View style={{flexDirection: 'row', alignItems: 'center'}}>
                            <Icon name={'trophy'} size={15} color={menuTitleColor} style={{backgroundColor:'transparent'}} />
                            <ReUpText appManager={appManager} style={{color:menuTitleColor, marginLeft: 10}}>
                              {classNames}
                            </ReUpText>
                          </View>
                        </View>
                      : null
                    }
                  </View>
                </View>
              </View>
            : null
          }
          {
            this.props.menuFeatures.map(function(menuFeature, index)
            {
              var iconName = menuFeature.data.icon.replace("fa-", "")
              var rippleColor = menu.props.menuHighlightColor; // not gonna use, rkbutton is foreground highlight, so no use
              return (
                <View key={index}>
                  <MKButton key={index} style={styles.menuItem}
                    backgroundColor={"transparent"}
                    onPress={function(){menu.didSelectFeature(menuFeature)}}
                    testID={menuFeature.data.title}
                    >
                    <View style={{flexDirection:'column', height:40}}>
                      <View style={styles.menuItemInnerContainer}>
                        <Icon style={styles.icon} name={iconName} size={24} color={menu.props.menuIconColor} />
                        <ReUpText appManager={appManager} isTitle={true} style={[styles.menuTitle, {color:menuTitleColor}]}>
                          {
                            appManager.useCapsButtons() ?
                              menuFeature.data.title.toUpperCase()
                            :
                              menuFeature.data.title
                          }
                        </ReUpText>
                      </View>
                    </View>
                  </MKButton>
                  <View style={{height:1, backgroundColor:'black',flexBasis:'auto', flexGrow:0, flexShrink:0, backgroundColor:menu.props.menuSeparatorColor, marginLeft:50}} />
                </View>
              )
            })
          }
          <View style={{height:20}} />
        </ScrollView>
      </View>);
  }
});

var styles = StyleSheet.create({
  container: {
      flex: 1,
      width:MENU_WIDTH + MENU_ADDITIONAL_WIDTH,
      backgroundColor:'transparent',
      alignItems: 'stretch'
  },
  menu: {
      paddingLeft:MENU_ADDITIONAL_WIDTH,
      flex: 1,
      width:MENU_WIDTH + MENU_ADDITIONAL_WIDTH,
      alignItems: 'stretch',
      flexDirection: 'column',
  },
  menuItem: {
    flex: 1,
    height:40,
    flexDirection:'column',
    justifyContent:'center',
  },
  menuItemInnerContainer: {
    flex: 1,
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'center',
  },
  icon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop:2,
    width:50,
  },
  menuTitle: {
    flex: 1,
  },
  image: {
    position: 'absolute',
    top:0, left:0, right:0, bottom:0
  },
});

module.exports = Menu;
